import { withInstall, withNoopInstall } from '@jdesign-vue/utils'

import Checkbox from './src/checkbox.vue'
import CheckboxButton from './src/checkbox-button.vue'
import CheckboxCard from './src/checkbox-card.vue'
import CheckboxGroup from './src/checkbox-group.vue'

export const JdCheckbox = withInstall(Checkbox, {
  CheckboxButton,
  CheckboxCard,
  CheckboxGroup,
})
export default JdCheckbox

export const JdCheckboxButton = withNoopInstall(CheckboxButton)
export const JdCheckboxCard = withNoopInstall(CheckboxCard)
export const JdCheckboxGroup = withNoopInstall(CheckboxGroup)

export * from './src/checkbox-group'
export * from './src/checkbox'
export * from './src/constants'
